import { Icon } from '~/components/icon'
import type { InputSelectSize } from '../../types'

export const InputSelectIcon = ({
  size,
  disabled,
  readonly,
  error,
  isOpen,
}: {
  size?: InputSelectSize
  disabled?: boolean
  readonly?: boolean
  error?: boolean
  isOpen: boolean
}) => {
  const iconColor = disabled
    ? 'colorTextNeutralDisabled'
    : readonly
      ? 'colorTextNeutralReadonly'
      : 'colorTextNeutralDefault'

  const mapSize = (size?: InputSelectSize) => {
    switch (size) {
      case 'md':
        return 'extra-small'
      case 'ml':
        return 'small'
      case 'lg':
        return 'small'
      case 'xl':
        return 'small'
      default:
        return 'extra-small'
    }
  }

  return (
    <div className="icon-container flex align-center">
      <Icon
        symbol={isOpen ? 'rdicon-chevron-up' : 'rdicon-chevron-down'}
        size={mapSize(size)}
        color={iconColor}
        data-testid="input-select-icon"
      />
    </div>
  )
}
